module.exports = __webpack_public_path__ + "static/img/logo119.cafdc9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo119.png
// module id = xVxx
// module chunks = 1